module.exports = __webpack_public_path__ + "static/media/network-wired.7778dc47.svg";